import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { partnerFollowRecordAdd, partnerFollowRecordEdit, partnerGetDropList } from '@/api/marketing/marketingManage'
import UploadFile from '@/components/UploadFile'
import type { PartnerManage } from '@/typings/api/marketingManage'
import { cloneDeep } from 'lodash-es'
import { selectForNumberValidate } from '@/utils/validate'

const __default__ = { name: 'partnerActivityFrom' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: false
  },
  view: {
    type: Boolean,
    default: false
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const dropList = ref([])
const form = ref<PartnerManage['partnerContact']>({})
const toggle = (row?: PartnerManage['partnerContact']) => {
  if (row) {
    form.value = cloneDeep(row)
    getPartnerGetDropList()
  } else {
    form.value = {}
  }
  visible.value = !visible.value
}
// 获取对接人下拉框
const getPartnerGetDropList = () => {
  partnerGetDropList({
    partnerId: form.value.partnerId
  }).then((res) => {
    dropList.value = res.data
  })
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      const { partnerName, ...other } = form.value
      if (form.value.id) {
        await partnerFollowRecordEdit(other)
        message.success('编辑成功')
        emit('success')
      } else {
        await partnerFollowRecordAdd({
          ...other
        })
        message.success('新增成功')
        emit('success', 'add')
      }
      toggle()
    } catch (error) {}
    loading.value = false
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_CosModal = _resolveComponent("CosModal")!

  return (_openBlock(), _createBlock(_component_CosModal, {
    visible: visible.value,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
    title: __props.disabled ? '查看' : form.value.id ? '编辑维护' : '新增维护',
    class: "clueMerge",
    width: "670px",
    onOk: handleSubmit,
    hideOk: __props.disabled,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CosViewContent, { view: __props.disabled }, {
        default: _withCtx(() => [
          (visible.value)
            ? (_openBlock(), _createBlock(_component_a_form, {
                key: 0,
                model: form.value,
                ref_key: "formRef",
                ref: formRef
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    name: "partnerName",
                    label: "合作伙伴名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.partnerName,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.partnerName) = $event)),
                        placeholder: "请输入",
                        disabled: true,
                        view: __props.disabled
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "partnerContactId",
                    rules: {
            required: true,
            validator: _unref(selectForNumberValidate),
            message: '请选择'
          },
                    label: "对接人"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        options: dropList.value,
                        view: __props.disabled,
                        fieldNames: { label: 'name', value: 'id' },
                        value: form.value.partnerContactId,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.partnerContactId) = $event)),
                        placeholder: "请选择"
                      }, null, 8, ["options", "view", "value"])
                    ]),
                    _: 1
                  }, 8, ["rules"]),
                  _createVNode(_component_a_form_item, {
                    name: "followTime",
                    rules: {
            required: true,
            message: '请选择'
          },
                    label: "维护时间"
                  }, {
                    default: _withCtx(() => [
                      (__props.disabled)
                        ? (_openBlock(), _createBlock(_component_CosInput, {
                            key: 0,
                            value: form.value.followTime,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.followTime) = $event)),
                            placeholder: "请输入",
                            view: __props.disabled
                          }, null, 8, ["value", "view"]))
                        : (_openBlock(), _createBlock(_component_a_date_picker, {
                            key: 1,
                            value: form.value.followTime,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.followTime) = $event)),
                            "show-time": "",
                            valueFormat: "YYYY/MM/DD HH:mm:ss",
                            style: {"width":"100%"}
                          }, null, 8, ["value"]))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    name: "fileUrl",
                    label: "附件上传"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadFile), {
                        value: form.value.fileUrl,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.fileUrl) = $event)),
                        view: __props.disabled
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "具体内容",
                    span: 24,
                    name: "content",
                    rules: {
            required: true,
            message: '请输入'
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosTextarea, {
                        value: form.value.content,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.content) = $event)),
                        placeholder: "请输入",
                        view: __props.disabled
                      }, null, 8, ["value", "view"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["view"])
    ]),
    _: 1
  }, 8, ["visible", "title", "hideOk", "confirmLoading"]))
}
}

})